import { Upload1Icon } from 'tdesign-icons-react';
import { Button, Input } from 'tdesign-react';

export const textDemos = [
  {
    title: '一级标题',
    class: 'nova-h1',
    demo: ['SPACE信息', '故事信息', '章节信息'],
  },
  {
    title: '二级标题',
    class: 'nova-h2',
    demo: ['位置示意图'],
  },
  {
    title: '三级标题',
    class: 'nova-h3',
    demo: ['详情页', '章节列表', '任务列表'],
  },
  {
    title: '文本-info',
    class: 'nova-text-info',
    demo: ['背景 | 角色 | 视角', '幕 | 角色 | 初始', '以下配置仅自己可见'],
  },
  {
    title: '文本-form',
    class: 'nova-text-form',
    demo: ['主标题', '关联世界观'],
  },
  {
    title: '文本-tips',
    class: 'nova-text-tips',
    demo: ['最多不要超过300字'],
  },
  {
    title: '文本-error',
    class: 'nova-text-error',
    demo: ['最多允许输入5个标签'],
  },
  {
    title: '导航-目录',
    class: 'nova-menu-title',
    demo: ['章节目录'],
  },
  {
    title: '导航-链接',
    class: 'nova-menu-link',
    demo: ['第一幕', '第二幕'],
  },
];

export const formDemos = [
  {
    props: 'upload_pic_big',
    label: '大图',
    render: 'pic',
    uiOptions: {
      isShowRichMedia: true,
      width: 207,
      height: 283,
      alertRender: '竖版 960x1280 像素，文件大小 ≤ 300KB',
    },
  },
  {
    props: 'upload_pic_small',
    label: '小图内涵文字',
    render: 'pic',
    uiOptions: {
      width: 140,
      height: 207,
      maxCount: 3,
      btnText: '上传卡片',
    },
  },
  {
    props: 'upload_pic_dialog',
    label: '弹窗图片上传',
    render: 'pic',
    defaultValue: {
      url: {
        url: 'https://community.image.video.qpic.cn/community_manage_woa_fbd86c-1_924937045_1713521340119062',
        localPath: '111',
        name: '文件名1',
      },
      showType: 1,
    },
    uiOptions: {
      isShowRichMedia: true,
      maxCount: 1,
      dialogConfig: {
        width: 370,
        height: 700,
      },
      width: 328,
      height: 472,
      alertRender: '格式：竖版 960×1280 像素，文件大小 ≤ 300KB',
      childRender: ({ url, name }: Record<string, string>) => {
        if (!url) {
          return <Button
            size="small" theme='default'
            icon={<Upload1Icon />}
          >点击上传图片</Button>;
        }
        return <div className='t-input'>{name}</div>;
      },
    },
  },
  {
    props: 'upload_video_dialog',
    label: '弹窗视频上传',
    render: 'video',
    defaultValue: {
      url: {
        url: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/starter/6a3128e1.mp4',
        localPath: '111',
        name: '文件名1',
      },
      showType: 1,
    },
    uiOptions: {
      isShowRichMedia: true,
      maxCount: 1,
      dialogConfig: {
        width: 370,
        height: 700,
      },
      width: 328,
      height: 472,
      alertRender: '格式：竖版 960×1280 像素，文件大小 ≤ 300KB',
      childRender: ({ url, name }: Record<string, string>) => {
        if (!url) {
          return <Button
            size="small" theme='default'
            icon={<Upload1Icon />}
          >点击上传视频</Button>;
        }
        return <div className='t-input'>{name}</div>;
      },
    },
  },
  {
    props: 'upload_audio_dialog',
    label: '弹窗音频上传',
    render: 'audio',
    defaultValue: {
      url: {
        url: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/starter/5b15184d.mp3',
        localPath: '111',
        name: '音频',
      },
      showType: 1,
    },
    uiOptions: {
      isShowRichMedia: true,
      maxCount: 1,
      dialogConfig: {
        width: 547,
        height: 340,
      },
      // alertRender: '格式：文件大小 ≤ 300KB',
      headerRender: <div
        style={{ paddingBottom: '15px', borderBottom: '1px solid var(--color-border)', marginBottom: '20px', fontSize: '14px' }}
        className="nova-text-info"
      >
        此时，角落里传来一声不大不小，但十分坚定的女声“我来喝“。
      </div>,
      childRender: ({ url, name }: Record<string, string>) => {
        if (!url) {
          return <Button
            theme='default'
            icon={<Upload1Icon />}
          >点击上传BGM</Button>;
        }
        return <Input style={{ width: '300px' }} readonly value={name} />;
      },
    },
  },
  {
    props: 'upload_file',
    label: '上传文件',
    render: 'file',
    defaultValue: {
      url: {
        url: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/starter/6a3128e1.mp4',
        localPath: '2222',
        name: '文件名1',
      },
      showType: 1,
    },
    uiOptions: {
      maxCount: 1,
      alertRender: '上传文件',
    },
  },
  {
    props: 'playerInfo',
    label: <div>
      玩家身份
      <span className="nova-text-tips">
        &nbsp;
        若不设定剧中身份，将默认使用玩家自己的头像昵称
      </span>
    </div>,
    render: 'customPlayInfo',
  },
];
